import { call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga'; // ✅ Import from 'redux-saga'
import { CalculationProcessStep } from 'store/types/assembler';
import { AxiosRequestHeaders } from 'axios';
import reqProvider from '../coreRequests';
import { SEARCH_API } from '../urlPaths';
import { getToken } from 'config/lib'


export function* renameCalculationProcessStep(uuid: string, name: string): SagaIterator {
  const token = getToken()
  const requestPath = `${SEARCH_API}/calculation-process-step/${uuid}`;
  const headers: AxiosRequestHeaders = {
    'Content-Type': 'application/json', Authorization: `Bearer ${token}`
  };

  try {

    const requestBody = {
      name: name,
    }

    // 2) Make the POST request
    const response = yield call(reqProvider.patchReq, requestPath, headers, requestBody);
    // 3) Return or dispatch the response data
    return response.data.data;
  } catch (error) {
    console.error("Error in postcalculationProcessStep:", error);
    return null;
  }
}

export function* saveNewCalculationProcessStep(name: string, model: CalculationProcessStep): SagaIterator {
  const token = getToken()
  const requestPath = `${SEARCH_API}/calculation-process-step`;
  const headers: AxiosRequestHeaders = {
    'Content-Type': 'application/json', Authorization: `Bearer ${token}`
  };

  const newcalculationProcessStep = {
    name: name,
    calculationProcessStep: model
  }

  try {
    // 2) Make the POST request
    const response = yield call(reqProvider.postReq, requestPath, headers, newcalculationProcessStep);

    // 3) Return or dispatch the response data
    return response.data;
  } catch (error) {
    console.error("Error in postcalculationProcessStep:", error);
    return null;
  }
}

export function* getCalculationProcessStepListing(): SagaIterator {
  const token = getToken()
  const requestPath = `${SEARCH_API}/calculation-process-step`;
  const headers: AxiosRequestHeaders = {
    'Content-Type': 'application/json', Authorization: `Bearer ${token}`
  };

  try {
    // 2) Make the POST request
    const response = yield call(reqProvider.getReq, requestPath, headers);

    // 3) Return or dispatch the response data
    return response;
  } catch (error) {
    console.error("Error in getcalculationProcessSteps:", error);
    return null;
  }
}

export function* getCalculationProcessStep(uuid: string): SagaIterator {
  const token = getToken()
  const requestPath = `${SEARCH_API}/calculation-process-step/search/${uuid}`;
  const headers: AxiosRequestHeaders = {
    'Content-Type': 'application/json', Authorization: `Bearer ${token}`
  };

  try {
    // 2) Make the POST request
    const response = yield call(reqProvider.getReq, requestPath, headers);

    // 3) Return or dispatch the response data
    return response.data;
  } catch (error) {
    console.error("Error in getcalculationProcessStep:", error);
    return null;
  }
}

export function* deleteCalculationProcessStep(uuid: string): SagaIterator {
  const token = getToken()
  const requestPath = `${SEARCH_API}/calculation-process-step/${uuid}`;
  const headers: AxiosRequestHeaders = {
    'Content-Type': 'application/json', Authorization: `Bearer ${token}`
  };

  try {
    // 2) Make the POST request
    const response = yield call(reqProvider.deleteReq, requestPath, headers);
    // 3) Return or dispatch the response data
    return response.data;
  } catch (error) {
    console.error("Error in deletecalculationProcessStep:", error);
    return null;
  }
}